import Header from '../components/Header.vue';
import LeftMenu from '../components/LeftMenu.vue';
import Footer from '../components/Footer.vue';
export default {
  name: 'Home',
  components: {
    Header,
    LeftMenu,
    Footer
  },
  data() {
    return {};
  },
  methods: {}
};